/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentProcessStatus {
    PENDING = 'Pending',
    FUNDED = 'Funded',
}